import React, { ReactElement } from 'react';
import FormTreeSelector from 'adapter/in/common/components/TreeSelector';
import { getErrorMessage, hasErrorFormSelector, onChangeSelect, SelectorContainerProps } from 'adapter/in/common/form/Selector';
import { SelectorType, TreeSelectorOption } from 'adapter/in/common/form/types';
import { useBaseSelectorContainer } from 'adapter/in/common/hooks/form/useBaseSelectorContainer';
import { useBaseDefaultValuesSelector } from 'adapter/in/common/hooks/form/useBaseDefaultValuesSelector';
import i18n from 'asset/translation';

type DefaultValuesTreeSelectorContainerProps = SelectorContainerProps & {
    style?: React.CSSProperties;
};

export const DefaultValuesTreeSelectorContainer = ({
    name,
    label,
    configType,
    dataDependsOn,
    affectsTo,
    disabled,
    properties,
    style,
    footer,
}: DefaultValuesTreeSelectorContainerProps): ReactElement => {
    const { value, onChange, invalid, error, shouldLoad } = useBaseSelectorContainer(name, {}, undefined, dataDependsOn, affectsTo);
    const defaultValues = properties?.defaultValues ? properties?.defaultValues : [];
    const { isLoading, maxSelectionLength, minSelectionLength, options } = useBaseDefaultValuesSelector<TreeSelectorOption>(
        SelectorType.TREE,
        configType,
        value,
        shouldLoad,
        defaultValues,
        onChange
    );

    return (
        <FormTreeSelector
            style={style}
            disabled={disabled}
            error={hasErrorFormSelector(invalid, error, options)}
            errorMessage={value ? getErrorMessage(value.value, minSelectionLength, maxSelectionLength) : ''}
            isLoading={isLoading}
            label={label}
            maxSelectionLength={maxSelectionLength}
            minSelectionLength={minSelectionLength}
            name={name}
            onChange={(selectedValues: string[]) =>
                onChangeSelect(minSelectionLength, maxSelectionLength, configType, value)(selectedValues, onChange)
            }
            tree={options}
            placeholder={
                minSelectionLength === 0 ? i18n.t('common.selector.placeholder.optional') : i18n.t('common.selector.placeholder.required')
            }
            value={value?.value}
            footer={footer}
        />
    );
};
